import type {
  OperationOption,
  DateFormatOption,
  ArrayConditionOption,
} from "../types";

export const stringOperationOptions: OperationOption[] = [
  {
    value: "concatenate",
    label: "Concatenar",
    description: "concatenate",
    HelperText: "unir dos o mas cadenas de texto en una sola",
  },
  {
    value: "replace",
    label: "Reemplazar",
    description: "replace",
    HelperText: "reemplazar una subcadena por otra",
  },
  {
    value: "replaceAll",
    label: "Reemplazar todo",
    description: "replaceAll",
    HelperText: "reemplazar todas las ocurrencias de una subcadena por otra",
  },
  {
    value: "slice",
    label: "Extraer texto desde índice",
    description: "slice",
    HelperText: "extraer una porción de texto desde un índice",
  },
  {
    value: "trim",
    label: "Quitar espacios a los extremos",
    description: "trim",
    HelperText: "eliminar espacios en blanco al inicio y final del texto",
  },
  {
    value: "toUpperCase",
    label: "Convertir a mayúsculas",
    description: "toUpperCase",
    HelperText: "convertir todo el texto a letras mayúsculas",
  },
  {
    value: "toLowerCase",
    label: "Converting a minúsculas",
    description: "toLowerCase",
    HelperText: "convertir todo el texto a letras minúsculas",
  },
  {
    value: "length",
    label: "Obtener longitud del texto",
    description: "length",
    HelperText: "obtener el número de caracteres del texto",
  },
  {
    value: "repeat",
    label: "Repetir texto",
    description: "repeat",
    HelperText: "repetir el texto un número específico de veces",
  },
  {
    value: "split",
    label: "Dividir texto por separador",
    description: "split",
    HelperText: "dividir el texto en un array usando un separador",
  },
];

export const numberOperationOptions: OperationOption[] = [
  {
    value: "sum",
    label: "Suma",
    description: "sum(+)",
    HelperText: "Suma de números",
  },
  {
    value: "subtract",
    label: "Resta",
    description: "subtract(-)",
    HelperText: "Resta de números",
  },
  {
    value: "multiply",
    label: "Multiplicar",
    description: "multiply(*)",
    HelperText: "Multiplicación de números",
  },
  {
    value: "divide",
    label: "Dividir",
    description: "divide(/)",
    HelperText: "División de números",
  },
  {
    value: "power",
    label: "Potenciar",
    description: "power(**)",
    HelperText: "Elevar un número a una potencia",
  },
  {
    value: "sqrt",
    label: "Raíz cuadrada",
    description: "sqrt",
    HelperText: "Calcular la raíz cuadrada de un número",
  },
  {
    value: "abs",
    label: "Valor absoluto",
    description: "abs",
    HelperText: "Obtener el valor absoluto de un número",
  },
  {
    value: "round",
    label: "Redondear",
    description: "round",
    HelperText: "Redondear un número al entero más cercano",
  },
  {
    value: "roundUp",
    label: "Redondear hacia arriba",
    description: "ceil",
    HelperText: "Redondear hacia arriba al siguiente entero",
  },
  {
    value: "roundDown",
    label: "Redondear hacia abajo",
    description: "floor",
    HelperText: "Redondear hacia abajo al entero anterior",
  },
  {
    value: "truncate",
    label: "Truncar",
    description: "truncate",
    HelperText: "Eliminar la parte decimal de un número",
  },
  {
    value: "log",
    label: "Logaritmo",
    description: "log",
    HelperText: "Calcular el logaritmo de un número",
  },
  {
    value: "ln",
    label: "Logaritmo natural",
    description: "ln",
    HelperText: "Calcular el logaritmo natural de un número",
  },
  {
    value: "exp",
    label: "Exponencial",
    description: "exp",
    HelperText: "Calcular e elevado a la potencia del número",
  },
  {
    value: "toString",
    label: "Formatear a string",
    description: "toString",
    HelperText: "Convertir el número a una cadena de texto",
  },
];

export const dateOperationOptions: OperationOption[] = [
  {
    value: "add",
    label: "Sumar tiempo",
    description: "add",
    HelperText: "Sumar tiempo a una fecha",
  },
  {
    value: "subtract",
    label: "Restar tiempo",
    description: "subtract",
    HelperText: "Restar tiempo a una fecha",
  },
  {
    value: "dateDiff",
    label: "Diferencia de fechas",
    description: "dateDiff",
    HelperText: "Obtener la diferencia entre dos fechas",
  },
  {
    value: "get",
    label: "Extraer tiempo",
    description: "get",
    HelperText: "Extraer una parte de la fecha",
  },
  {
    value: "toString",
    label: "Formatear a string",
    description: "toString",
    HelperText: "Conviertir la fecha a texto segun el formato elegido",
  },
];

export const boolOperationOptions: OperationOption[] = [
  {
    value: "not",
    label: "Invertir valor",
    description: "not(!)",
    HelperText: "Invertir el valor booleano",
  },
  {
    value: "and",
    label: "AND",
    description: "and(&&)",
    HelperText: "Evaluar si ambas condiciones son verdaderas",
  },
  {
    value: "or",
    label: "OR",
    description: "or(||)",
    HelperText: "Evaluar si al menos una condición es verdadera",
  },
  {
    value: "xor",
    label: "XOR",
    description: "xor",
    HelperText: "Evaluar si una condición es verdadera y la otra falsa",
  },
  {
    value: "nand",
    label: "NAND",
    description: "nand",
    HelperText: "Evaluar si al menos una condición es falsa (negación de AND)",
  },
  {
    value: "nor",
    label: "NOR",
    description: "nor",
    HelperText: "Evaluar si ambas condiciones son falsas (negación de OR)",
  },
  {
    value: "xnor",
    label: "XNOR",
    description: "xnor",
    HelperText:
      "Evaluar si ambas condiciones tienen el mismo valor (negación de XOR)",
  },
  {
    value: "toNumber",
    label: "Convertir a número",
    description: "toNumber",
    HelperText: "Convertir el valor booleano a número (true=1, false=0)",
  },
  {
    value: "toString",
    label: "Convertir a texto",
    description: "toString",
    HelperText: "Convertir el valor booleano a texto",
  },
];

export const arrayOperationOptions: OperationOption[] = [
  {
    value: "pop",
    label: "Quitar último elemento",
    description: "pop",
    HelperText: "Elimina el último elemento del array",
  },
  {
    value: "shift",
    label: "Quitar primer elemento",
    description: "shift",
    HelperText: "Elimina el primer elemento del array",
  },
  {
    value: "splice",
    label: "Eliminar en índice",
    description: "splice",
    HelperText: "Elimina elementos desde un índice específico",
  },
  {
    value: "sortAsc",
    label: "Ordenar",
    description: "sortAsc",
    HelperText: "Ordena los elementos del array de forma ascendente",
  },
  {
    value: "sortDesc",
    label: "Ordenar al revés",
    description: "sortDesc",
    HelperText: "Ordena los elementos del array de forma descendente",
  },
  {
    value: "reverse",
    label: "Invertir orden",
    description: "reverse",
    HelperText: "Invierte el orden de los elementos del array",
  },
  {
    value: "map",
    label: "Recorrer y transformar",
    description: "map",
    HelperText: "Aplica una transformación a cada elemento del array",
  },
  {
    value: "filter",
    label: "Filtrar",
    description: "filter",
    HelperText: "Filtra elementos del array según una condición",
  },
  {
    value: "reduce",
    label: "Reducir",
    description: "reduce",
    HelperText: "Reduce el array a un solo valor aplicando una función",
  },
  {
    value: "length",
    label: "Obtener tamaño",
    description: "length",
    HelperText: "Obtiene el número de elementos en el array",
  },
  {
    value: "indexOf",
    label: "Buscar índice",
    description: "indexOf",
    HelperText: "Busca el índice de la primera ocurrencia de un elemento",
  },
  {
    value: "filterLength",
    label: "Buscar ocurrencias",
    description: "filterLength",
    HelperText: "Cuenta cuántas veces aparece un elemento en el array",
  },
  {
    value: "trim",
    label: "Recortar",
    description: "trim",
    HelperText: "Elimina elementos vacíos o nulos del array",
  },
  {
    value: "chunk",
    label: "Dividir en partes",
    description: "chunk",
    HelperText: "Divide el array en grupos más pequeños de tamaño específico",
  },
  {
    value: "set",
    label: "Eliminar duplicados",
    description: "set",
    HelperText: "Elimina elementos duplicados del array",
  },
];

export const dateGetFormatOptions: DateFormatOption[] = [
  { value: "year", label: "Año", description: "FullYear" },
  { value: "month", label: "Meses", description: "Months" },
  { value: "day", label: "Días", description: "Days" },
  { value: "hour", label: "Horas", description: "Hours" },
  { value: "minute", label: "Minutos", description: "Minutes" },
  { value: "weekday", label: "Nombre del dia", description: "Weekday" },
  { value: "MonthName", label: "Nombre del mes", description: "MonthName" },
  { value: "timestamp", label: "Tiempo", description: "timestamp" },
];

export const dateToStringFormatOptions: DateFormatOption[] = [
  { value: "YYYY-MM-DD", label: "2025-07-29", description: "YYYY-MM-DD" },
  { value: "DD/MM/YYYY", label: "29/07/2025", description: "DD/MM/YYYY" },
  { value: "MM/DD/YYYY", label: "07/29/2025", description: "MM/DD/YYYY" },
  {
    value: "dddd, MMMM D",
    label: "martes, julio 29",
    description: "dddd, MMMM D",
  },
  { value: "D MMM YYYY", label: "29 jul 2025", description: "D MMM YYYY" },
  {
    value: "YYYY-MM-DD HH:mm",
    label: "2025-07-29 14:30",
    description: "YYYY-MM-DD HH:mm",
  },
  { value: "HH:mm a", label: "02:30 PM", description: "HH:mm a" },
];

export const arrayConditionOptions: ArrayConditionOption[] = [
  {
    value: "equals",
    label: "Es igual a",
    description: "Es igual a",
  },
  {
    value: "notEquals",
    label: "No es igual a",
    description: "No es igual a",
  },
  {
    value: "contains",
    label: "Contiene el texto",
    description: "Contiene el texto",
  },
  {
    value: "notContains",
    label: "No contiene el texto",
    description: "No contiene el texto",
  },
  {
    value: "startsWith",
    label: "Inicia con",
    description: "Inicia con",
  },
  {
    value: "endsWith",
    label: "Termina con",
    description: "Termina con",
  },
  {
    value: "characterCount",
    label: "Número de caracteres",
    description: "Número de caracteres",
  },
];

export const arrayFunctionOptions: ArrayConditionOption[] = [
  {
    value: "toUpperCase",
    label: "A mayúsculas",
    description: "toUpperCase",
  },
  {
    value: "toLowerCase",
    label: "A minúsculas",
    description: "toLowerCase",
  },
  {
    value: "trim",
    label: "Recortar espacios",
    description: "trim",
  },
  {
    value: "slice",
    label: "Obtener caracteres",
    description: "slice",
  },
  {
    value: "prepend",
    label: "Insertar texto al inicio",
    description: "prepend",
  },
  {
    value: "append",
    label: "Insertar texto al final",
    description: "append",
  },
  {
    value: "replace",
    label: "Reemplazar texto",
    description: "replace",
  },
  {
    value: "normalize",
    label: "Quitar acentos",
    description: "normalize",
  },
  {
    value: "reverse",
    label: "Invertir texto",
    description: "reverse",
  },
];
